"use client"

import { createContext, useContext, type ReactNode } from "react"

/** Which consent-gated Google services are switched on. */
export type ConsentServices = { measurementId: string; mapsEnabled: boolean }

const ServicesContext = createContext<ConsentServices>({ measurementId: "", mapsEnabled: false })

/**
 * Hands the resolved GA4 measurement ID and the map switch to the consent components.
 * The public layouts read them on the server, so the browser never calls the settings
 * endpoint. "" and false mean the service is off.
 */
export function AnalyticsConfigProvider({
    measurementId,
    mapsEnabled,
    children,
}: {
    measurementId: string
    mapsEnabled: boolean
    children: ReactNode
}) {
    const value = { measurementId, mapsEnabled }
    return <ServicesContext.Provider value={value}>{children}</ServicesContext.Provider>
}

/** The measurement ID for this page, or "" when analytics is off. */
export function useMeasurementId(): string {
    return useContext(ServicesContext).measurementId
}

/** Which services the cookie box covers on this page. */
export function useConsentServices(): ConsentServices {
    return useContext(ServicesContext)
}
